import { Flex, Icon, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { convertDataRastreio, IsEmpty } from "config/functions";
import { consultarRastreio } from "config/apis/requests";

import { MdLocalShipping, MdCheckCircle, MdCancel } from "react-icons/md";
export default function TimelineRow(props: {
  nrRastreamento: any;
  idCliente: any;
  idItemPedido: any;
  idPedido: any;
  idProduto: any;
  item: any;
}) {
  const { nrRastreamento, idItemPedido, idPedido, idProduto } = props;
  const [rastreioCartao, setRastreioCartao] = useState([]);
  const statusCartao = (produto: any) => {
    switch (produto) {
      case 6:
        return (
          <>
            <Text color={"#000"} fontSize="md" me="6px" fontWeight="700">
              Cartão conta transporte
            </Text>
            <Text color={"black.600"} fontSize="md" me="2px" fontWeight="200">
              Clique no rastreio para obter mais informações:{" "}
            </Text>
            <Text color={"blue.600"} fontSize="md" me="2px" fontWeight="600">
              <a
                href={`https://www.flashcourier.com.br/rastreio/${nrRastreamento}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {nrRastreamento}
              </a>
            </Text>
          </>
        );
      case 2:
        return (
          <>
            <Text color={"black"} fontSize="md" me="6px" fontWeight="700">
              Cartão benefício VT
            </Text>
            <Text color={"black.600"} fontSize="md" me="2px" fontWeight="200">
              Clique no rastreio para obter mais informações:{" "}
            </Text>
            <Text color={"blue.600"} fontSize="md" me="2px" fontWeight="600">
              <a
                href={`https://www.flashcourier.com.br/rastreio/${nrRastreamento}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {nrRastreamento}
              </a>
            </Text>
          </>
        );
      case 3:
        return (
          <>
            <Text color={"#E5B02D"} fontSize="md" me="6px" fontWeight="700">
              Cartão conta Jaé gratuidade
            </Text>
            <Text color={"black.600"} fontSize="md" me="2px" fontWeight="700">
              Clique no rastreio para obter mais informações:{" "}
            </Text>
            <Text color={"blue.600"} fontSize="md" me="2px" fontWeight="600">
              <a
                href={`https://www.flashcourier.com.br/rastreio/${nrRastreamento}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {nrRastreamento}
              </a>
            </Text>
          </>
        );
      default:
        return (
          <>
            <Text color={"#E5B02D"} fontSize="md" me="6px" fontWeight="700">
              Cartão Jaé
            </Text>
            <Text color={"black.600"} fontSize="md" me="2px" fontWeight="700">
              Clique no rastreio para obter mais informações:{" "}
            </Text>
            <Text color={"blue.600"} fontSize="md" me="2px" fontWeight="600">
              <a
                href={`https://www.flashcourier.com.br/rastreio/${nrRastreamento}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {nrRastreamento}
              </a>
            </Text>
          </>
        );
    }
  };
  const statusIcon = (rastreio: any) => {
    switch (parseInt(rastreio?.eventoId)) {
      case 4300:
      case 2500:
      case 5000:
        return (
          <>
            <Flex direction={"row"} align={"center"}>
              <Icon
                as={MdCheckCircle}
                //bg={"green.300"}
                color={"green.300"}
                h={"60px"}
                w={"56px"}
                pe="6px"
                zIndex="1"
                position="relative"
                right={document.documentElement.dir === "rtl" ? "-8px" : ""}
                left={document.documentElement.dir === "rtl" ? "" : "-8px"}
              />
              <Flex direction={"column"}>
                {idProduto && statusCartao(idProduto)}
                <Text color={"black"} fontSize="md" me="6px" fontWeight="700">
                  Entregue em:
                </Text>
                {rastreio?.ocorrencia && (
                  <>
                    <Text
                      color={"black"}
                      fontSize="sm"
                      me="6px"
                      fontWeight="400"
                    >
                      {convertDataRastreio(rastreio?.ocorrencia)}
                    </Text>
                  </>
                )}
              </Flex>
            </Flex>
          </>
        );
      case 4200:
      case 4255:
      case 1500:
      case 2400:
      case 6110:
      case 6400:
      case 6500:
        return (
          <>
            <Flex direction={"row"} align={"center"}>
              <Icon
                as={MdCancel}
                //bg={"green.300"}
                color={"red.600"}
                h={"60px"}
                w={"56px"}
                pe="6px"
                zIndex="1"
                position="relative"
                right={document.documentElement.dir === "rtl" ? "-8px" : ""}
                left={document.documentElement.dir === "rtl" ? "" : "-8px"}
              />
              <Flex direction={"column"}>
                {idProduto && statusCartao(idProduto)}
                <Text color={"black"} fontSize="md" me="6px" fontWeight="700">
                  Cartão não entregue.
                </Text>
                <Text color={"black"} fontSize="sm" me="6px" fontWeight="400">
                  {rastreio?.ocorrencia}
                </Text>
              </Flex>
            </Flex>
          </>
        );
      case 1100:
      case 1400:
        return (
          <>
            <Flex direction={"row"} align={"center"}>
              <Icon
                as={MdCancel}
                //bg={"green.300"}
                color={"red.600"}
                h={"60px"}
                w={"56px"}
                pe="6px"
                zIndex="1"
                position="relative"
                right={document.documentElement.dir === "rtl" ? "-8px" : ""}
                left={document.documentElement.dir === "rtl" ? "" : "-8px"}
              />
              <Flex direction={"column"}>
                {idProduto && statusCartao(idProduto)}
                <Text color={"black"} fontSize="md" me="6px" fontWeight="700">
                  Objeto postado
                </Text>
              </Flex>
            </Flex>
          </>
        );

      case 6700:
        return (
          <>
            <Flex direction={"row"} align={"center"}>
              <Icon
                as={MdLocalShipping}
                //bg={"green.300"}
                color={"yellow.600"}
                h={"60px"}
                w={"56px"}
                pe="6px"
                zIndex="1"
                position="relative"
                right={document.documentElement.dir === "rtl" ? "-8px" : ""}
                left={document.documentElement.dir === "rtl" ? "" : "-8px"}
              />
              <Flex direction={"column"}>
                {idProduto && statusCartao(idProduto)}
                <Text color={"black"} fontSize="md" me="6px" fontWeight="700">
                  Objeto reenviado
                </Text>
                <Text color={"black"} fontSize="sm" me="6px" fontWeight="400">
                  {rastreio?.ocorrencia}
                </Text>
              </Flex>
            </Flex>
          </>
        );

      case 4100:
        return (
          <>
            <Flex direction={"row"} align={"center"}>
              <Icon
                as={MdLocalShipping}
                //bg={"green.300"}
                color={"blue.600"}
                h={"60px"}
                w={"56px"}
                pe="6px"
                zIndex="1"
                position="relative"
                right={document.documentElement.dir === "rtl" ? "-8px" : ""}
                left={document.documentElement.dir === "rtl" ? "" : "-8px"}
              />
              <Flex direction={"column"}>
                {idProduto && statusCartao(idProduto)}
                <Text color={"black"} fontSize="md" me="6px" fontWeight="700">
                  Entrega em andamento
                </Text>
                <Text color={"black"} fontSize="sm" me="6px" fontWeight="400">
                  {rastreio?.ocorrencia}
                </Text>
              </Flex>
            </Flex>
          </>
        );
      default:
        return (
          <>
            <Flex direction={"row"} align={"center"}>
              <Icon
                as={MdLocalShipping}
                color={"yellow.600"}
                h={"60px"}
                w={"56px"}
                pe="6px"
                zIndex="1"
                position="relative"
                right={document.documentElement.dir === "rtl" ? "-8px" : ""}
                left={document.documentElement.dir === "rtl" ? "" : "-8px"}
              />
              <Flex direction={"column"}>
                {idProduto && statusCartao(idProduto)}
                <Text color={"black"} fontSize="md" me="6px" fontWeight="700">
                  Objeto em trânsito
                </Text>
                <Text color={"black"} fontSize="sm" me="6px" fontWeight="400">
                  {rastreio?.ocorrencia}
                </Text>
              </Flex>
            </Flex>
          </>
        );
    }
  };

  useEffect(() => {
    if ((idPedido && idItemPedido) || nrRastreamento) {
      consultarRastreio(nrRastreamento).then((resultRastreio: any) => {
        if (
          resultRastreio !== 400 &&
          resultRastreio !== 500 &&
          !IsEmpty(resultRastreio) &&
          resultRastreio.hawbs !== null
        ) {
          const historicoAtual = resultRastreio.hawbs[0].historico.map(
            (item: any) => ({
              ocorrencia: item.ocorrencia,
              eventoId: item.eventoId,
              evento: item.evento,
            })
          );
          const parseDate = (dateString: string): Date => {
            const [day, month, year, hours, minutes, seconds, milliseconds] =
              dateString.split(/[/\s:.]/);
            return new Date(
              `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`
            );
          };

          const ultimoRegistro = historicoAtual.reduce(
            (maisRecente: any, registroAtual: any) => {
              const dateMaisRecente = parseDate(maisRecente.ocorrencia);
              const dateAtual = parseDate(registroAtual.ocorrencia);
              return dateAtual > dateMaisRecente ? registroAtual : maisRecente;
            }
          );

          setRastreioCartao([ultimoRegistro]);
        } else {
          setRastreioCartao(null);
        }
      });
    }
  }, [idItemPedido]);

  return (
    <Flex alignItems="center" minH="78px" justifyContent="start" mb="5px">
      {rastreioCartao !== null ? (
        <Flex direction="column" h="100%">
          {statusIcon(rastreioCartao[0])}

          {/* <Box w="2px" bg="gray.200" h={"15px"} /> */}
        </Flex>
      ) : (
        <Flex direction={"row"} align={"center"}>
          <Icon
            as={MdCancel}
            //bg={"green.300"}
            color={"red.600"}
            h={"60px"}
            w={"56px"}
            pe="6px"
            zIndex="1"
            position="relative"
            right={document.documentElement.dir === "rtl" ? "-8px" : ""}
            left={document.documentElement.dir === "rtl" ? "" : "-8px"}
          />
          <Flex direction={"column"}>
            {idProduto && statusCartao(idProduto)}
            <Text color={"red"} fontSize="sm" me="6px" fontWeight="300">
              Sem dados de rastreio!
            </Text>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
}
